import React from "react";
import styled from "styled-components";
import { TYPE_PRIMARY } from "../../../lib/ui";
import { BTN_MEDIUM, Button } from "../../../lib/form";
import iconsToRemember from "./icons-to-remember.png";
import Timer from "./Timer";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;
const Img = styled.img`
    margin-top: 20px;
    width: 360px;
    height: 227px;
`;

type Props = {
    onStart: () => void;
};
type State = {
    count: number;
};

export default class Start extends React.Component<Props, State> {
    private intervalId?: ReturnType<typeof setInterval>;

    state = {
        count: 0,
    };

    componentDidMount() {
        this.intervalId = setInterval(this.onInterval, 1000);
    }

    componentWillUnmount() {
        const i = this.intervalId;
        if (typeof i !== "undefined") {
            clearInterval((i as unknown) as number);
        }
    }

    onInterval = () => {
        this.setState({
            count: this.state.count + 1,
        });
    };

    render() {
        const { onStart } = this.props;
        const { count } = this.state;

        return (
            <Container>
                <Img src={iconsToRemember} />
                <Timer seconds={30} onFinish={onStart} />

                {count > 15 && (
                    <Button
                        width="120px"
                        type={TYPE_PRIMARY}
                        size={BTN_MEDIUM}
                        onClick={onStart}
                        messageId="onBoarding.startEditor"
                    />
                )}
            </Container>
        );
    }
}
